/* THE DOSSIER — motion controller
 *
 * Entrance reveals only. No parallax, no scroll-jacking, no counters.
 *
 * SAFETY PRINCIPLE: motion is a nicety, content is not. Nothing here may leave
 * text permanently invisible. Four independent guards ensure content shows:
 *   1. IntersectionObserver (the normal path)
 *   2. a throttled scroll/resize sweep that reveals anything in view
 *   3. an immediate first-paint sweep for content already on screen
 *   4. a hard failsafe timer that reveals everything, unconditionally
 * If any single mechanism fails, the others still render the page.
 */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = [];

  function reveal(el) {
    if (el && !el.classList.contains('dsr-in')) el.classList.add('dsr-in');
  }

  function revealAll() {
    for (var i = 0; i < targets.length; i++) reveal(targets[i]);
  }

  function sweep() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < targets.length; i++) {
      var el = targets[i];
      if (el.classList.contains('dsr-in')) continue;
      var r = el.getBoundingClientRect();
      // Reveal anything intersecting the viewport, plus anything already
      // scrolled past (bottom above the fold) so nothing is stranded.
      if (r.top < vh * 0.94 && r.bottom > -50) reveal(el);
    }
  }

  function throttle(fn, ms) {
    var t = 0, queued = false;
    return function () {
      var now = Date.now();
      if (now - t >= ms) { t = now; fn(); }
      else if (!queued) {
        queued = true;
        setTimeout(function () { queued = false; t = Date.now(); fn(); }, ms);
      }
    };
  }

  function init() {
    var root = document.querySelector('.dsr');
    if (!root) return;

    var found = root.querySelectorAll(
      '.dsr-section > .dsr-container > *, .dsr-rail, .dsr-ev__item, .dsr-method__step, .dsr-path__item, .dsr-cat__item'
    );
    if (!found.length) return;

    var lastSection = null, idx = 0;
    for (var i = 0; i < found.length; i++) {
      var el = found[i];
      var section = el.closest ? el.closest('.dsr-section') : null;
      if (section !== lastSection) { lastSection = section; idx = 0; }
      el.setAttribute('data-dsr-reveal', '');
      el.style.setProperty('--dsr-i', Math.min(idx, 6));
      targets.push(el);
      idx++;
    }

    // Guard 4 first: whatever else happens, everything is visible by 2.5s.
    setTimeout(revealAll, 2500);

    if (REDUCED || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    // Guard 1
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          reveal(entries[i].target);
          io.unobserve(entries[i].target);
        }
      }
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });

    for (var j = 0; j < targets.length; j++) io.observe(targets[j]);

    // Guard 2
    var onScroll = throttle(sweep, 120);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // Guard 3
    sweep();
    requestAnimationFrame(sweep);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Last resort: if init threw for any reason, un-hide everything on load.
  window.addEventListener('load', function () {
    setTimeout(function () {
      var hidden = document.querySelectorAll('[data-dsr-reveal]:not(.dsr-in)');
      if (hidden.length && !targets.length) {
        for (var i = 0; i < hidden.length; i++) hidden[i].classList.add('dsr-in');
      }
    }, 3000);
  });
})();
